import { LOGIN_SUCCESS, LOGIN_FAILED, LOCKOUT,LOGOUT_SUCCESS, MFA_REQUIRED,
    ACCOUNT_SERVICE_STATUS_UPDATED, 
    LOGIN_BAD_MAGIC} from '../../actions/actionTypes';

const initialState = {
    account: null,
    loginError: false,
    mfaRequired: false,
    accountServiceEnabled: false,
    lockout: false,
    isGuest: false,
    announcement: {
        banner_enabled: false
    },
    loginNotice: {
        notice_enabled: false
    }
};

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return Object.assign({}, state, {
                account: action.profile,
                isGuest: action.profile.is_guest,
                loginError: false,
                mfaRequired: false,
                lockout: false
            });

        case LOGIN_FAILED:
            return Object.assign({}, state, {
                account: null,
                loginError: true,
                mfaRequired: false,
                lockout: false
            });

        case LOGIN_BAD_MAGIC:
            return Object.assign({}, state, {
                account: null,
                loginError: true,
                mfaRequired: false,
                lockout: false
            })

        case LOCKOUT:
            return Object.assign({}, state, {
                account: null,
                loginError: false,
                mfaRequired: false,
                lockout: true
            });

        case MFA_REQUIRED:
            return Object.assign({}, state, {
                account: null,
                loginError: false,
                mfaRequired: true,
                lockout: false
            });

        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                account: null,
                loginError: false,
                mfaRequired: false,
                lockout: false
            });

        case ACCOUNT_SERVICE_STATUS_UPDATED:
            return Object.assign({}, state, {
                accountServiceEnabled: action.enabled,
                announcement: action.announcement,
                loginNotice: action.loginNotice
            });

        default:
            return state;
    }
};

export default loginReducer;
